import React from 'react'
import PropTypes from 'prop-types'
import ClasstalkTabAd from '@/features/preview/components/molecules/ClasstalkTabAd'

const AdPreviewClasstalkTabType = ({ imageUrl }) => (
  <ClasstalkTabAd
    imageUrl={imageUrl}
  />
)

AdPreviewClasstalkTabType.propTypes = {
  imageUrl: PropTypes.string.isRequired,
}

export default AdPreviewClasstalkTabType
